import repository from 'client/repository';
import swipeTypes from 'areas/swipes/domain/swipeTypes';
import alertActions from 'areas/alert/actions';
import progressActions from 'areas/progress/actions';

import {
    requestVisitorPass,
    receiveVisitorPass,
    showVisitorPassPage
} from '../../cards/actions';

/*
 * This is the action that gets performed when a persons card is read during a swipe in operation
 */

export default {
    byQRCode: (qrCode, cardHolderPageContext) => {

        const actionPrefix = 'QR_LOOKUP';

        function failure(error) {
            return { type: `${actionPrefix}_FAILURE`, error };
        }

        return async dispatch => {
            try {

                // Signal and do the load of the card data
                dispatch(requestVisitorPass(qrCode));
                dispatch(progressActions.report('Fetching visitor pass'));

                const pass = await repository.cards.getVisitorPassByQR(qrCode);

                if (pass === "") {
                    dispatch(progressActions.hide());
                    dispatch(alertActions.error('The scanned visitor pass could not be found.'));
                }
                else {
                    pass.swipeType = swipeTypes.QR;
                    pass.dateRetrieved = new Date().toISOString();

                    // Signal the card data has been received
                    dispatch(receiveVisitorPass(qrCode, pass));

                    dispatch(progressActions.hide());

                    dispatch(showVisitorPassPage(qrCode, cardHolderPageContext));
                }

            }
            catch (error) {
                // Generic error handler, a number of different errors could have happened here
                dispatch(alertActions.error(error.failureReason || error.toString()));
                dispatch(failure(error.failureReason || error.toString()));
                dispatch(progressActions.hide());
            }
        };
    }
}